import type { LucideIcon } from 'lucide-react';
import {
  BotIcon,
  BrainCircuitIcon,
  CableIcon,
  CpuIcon,
  FolderKanbanIcon,
  LayoutDashboardIcon,
  ShipIcon,
  TrendingUpIcon,
} from 'lucide-react';

export interface ServiceEntry {
  id: string;
  name: string;
  description: string;
  icon: LucideIcon;
  prodHost: string;
  isDefault: boolean;
  tenantIds: string[];
}

export const SERVICE_REGISTRY: ServiceEntry[] = [
  {
    id: 'ai-gateway-main',
    name: 'AI Gateway',
    description: '智算网关',
    icon: BrainCircuitIcon,
    prodHost: 'ai.tos.run',
    isDefault: true,
    tenantIds: [],
  },
  {
    id: 'tensor-agent-main',
    name: 'Tensor Agent',
    description: '智能体平台',
    icon: BotIcon,
    prodHost: 'agent.tos.run',
    isDefault: true,
    tenantIds: [],
  },
  {
    id: 'erp-foreign-trade',
    name: '同思外贸',
    description: '进出口业务管理',
    icon: ShipIcon,
    prodHost: 'trade.tos.run',
    isDefault: false,
    tenantIds: ['org-tairui'],
  },
  {
    id: 'quotation-cable',
    name: '电缆报价',
    description: '电缆报价系统',
    icon: CableIcon,
    prodHost: 'cable.tos.run',
    isDefault: false,
    tenantIds: ['org-antong'],
  },
  {
    id: 'tensor-os',
    name: 'Tensor OS',
    description: '算力管理平台',
    icon: CpuIcon,
    prodHost: 'demo.tos.run',
    isDefault: false,
    tenantIds: ['org-tensor-os-demo'],
  },
  {
    id: 'fde-portal-main',
    name: 'FDE Portal',
    description: '数据管理平台',
    icon: LayoutDashboardIcon,
    prodHost: 'fde.tos.run',
    isDefault: false,
    tenantIds: ['org-guanlan'],
  },
  {
    id: 'template-project-management',
    name: '同思项目',
    description: '项目协作管理',
    icon: FolderKanbanIcon,
    prodHost: 'template.tos.run',
    isDefault: false,
    tenantIds: [
      'org-tairui',
      'org-antong',
      'org-tieta',
      'org-guanlan',
      'org-guoyuan',
    ],
  },
  {
    id: 'finance-research',
    name: '若见 AI',
    description: '金融研究平台',
    icon: TrendingUpIcon,
    prodHost: 'finance.tos.run',
    isDefault: false,
    tenantIds: ['org-finance-research-demo'],
  },
];

export function getServiceUrl(entry: ServiceEntry): string {
  if (
    typeof window !== 'undefined' &&
    window.location.hostname === 'localhost'
  ) {
    return '#';
  }
  return `https://${entry.prodHost}`;
}

export function getAccessibleServices(orgId: string): ServiceEntry[] {
  return SERVICE_REGISTRY.filter((s) => {
    if (s.isDefault) return true;
    return s.tenantIds.includes(orgId);
  });
}
